<template>
  <div class="main main--login main--background">
    <div class="container register">
      <img
        src="../../assets/img/geberit-logo-1.png"
        alt="geberit"
        class="register__logo"
      />
      <form
        method="post"
        class="form"
        v-bind:class="{ pending: pending }"
        @submit="register"
      >
        <div class="register__columns">
          <!-- Pierwsza para pól -->
          <div class="register__row">
            <div class="form__input-container">
              <input
                type="text"
                name="first_name"
                v-model="form.first_name"
                class="form__input"
                placeholder="Imię"
              />
              <validation-error :error="form.errors.first_name" />
            </div>
            <div class="form__input-container">
              <input
                type="text"
                name="last_name"
                v-model="form.last_name"
                class="form__input"
                placeholder="Nazwisko"
              />
              <validation-error :error="form.errors.last_name" />
            </div>
          </div>

          <!-- Druga para pól -->
          <div class="register__row">
            <div class="form__input-container">
              <input
                type="text"
                name="email"
                v-model="form.email"
                class="form__input"
                placeholder="Twój adres e-mail"
              />
              <validation-error :error="form.errors.email" />
            </div>
            <div class="form__input-container">
              <input
                type="text"
                name="phone"
                v-model="form.phone"
                class="form__input"
                placeholder="Telefon"
              />
              <validation-error :error="form.errors.phone" />
            </div>

            <div class="form__input-container">
              <input
                type="text"
                name="website"
                v-model="form.website"
                class="form__input"
                placeholder="Strona internetowa"
              />
              <validation-error :error="form.errors.website" />
            </div>
          </div>

          <!-- Trzecia para pól -->
          <div class="register__row">
            <div class="form__input-container">
              <input
                type="text"
                name="nip"
                v-model="form.nip"
                class="form__input"
                placeholder="NIP"
              />
              <validation-error :error="form.errors.nip" />
            </div>
            <div class="form__input-container">
              <input
                type="text"
                name="company"
                v-model="form.company"
                class="form__input"
                placeholder="Nazwa firmy"
              />
              <validation-error :error="form.errors.company" />
            </div>
          </div>

          <!-- Czwarta para pól -->
          <div class="register__row">
            <div class="form__input-container">
              <input
                type="text"
                name="address.address"
                v-model="form.address.address"
                class="form__input"
                placeholder="Adres"
              />
              <validation-error :error="form.errors['address.address']" />
            </div>
          </div>

          <!-- Piąta para pól -->
          <div class="register__row">
            <div class="form__input-container">
              <input
                type="text"
                name="address.postal_code"
                v-model="form.address.postal_code"
                class="form__input"
                placeholder="Kod pocztowy"
              />
              <validation-error :error="form.errors['address.postal_code']" />
            </div>
            <div class="form__input-container flex-2">
              <input
                type="text"
                name="address.city"
                v-model="form.address.city"
                class="form__input"
                placeholder="Miejscowość"
              />
              <validation-error :error="form.errors['address.city']" />
            </div>
          </div>

          <!-- Szósta para pól -->
          <div class="register__row">
            <div class="form__input-container">
              <input
                type="password"
                name="password"
                v-model="form.password"
                class="form__input"
                placeholder="Hasło"
              />
              <validation-error :error="form.errors.password" />
            </div>
            <div class="form__input-container">
              <input
                type="password"
                name="password_confirmation"
                v-model="form.password_confirmation"
                class="form__input"
                placeholder="Powtórz hasło"
              />
              <validation-error :error="form.errors.password_confirmation" />
            </div>
          </div>
        </div>

        <div>
          <div class="form__input-container">
            <input
              type="checkbox"
              id="agree_1"
              v-model="form.agree_1"
              class="form__checkbox"
            />

            <label for="agree_1" class="form-check-label"
              ><span style="color: red; margin-left: 15px">*</span> Wyrażam
              zgodę na przetwarzanie moich danych osobowych, wskazanych w
              formularzu przez spółkę Geberit sp. z o.o. z siedzibą w Warszawie,
              przy ul. Postępu 1, 02-676 Warszawa, wpisaną do rejestru
              przedsiębiorców KRS pod numerem: 0000038776 (dalej jako
              Administrator) w celu organizacji, przeprowadzenia i wzięcia
              udziału w Programie Geberit PRO oraz otrzymania nagrody w związku
              z wzięciem udziału w tym Programie. Oświadczam, że zapoznałem/am
              się z treścią obowiązku informacyjnego i akceptuję jego treść.
            </label>

            <validation-error :error="form.errors.agree_1" />
          </div>

          <div class="form__input-container">
            <input
              type="checkbox"
              id="agree_2"
              v-model="form.agree_2"
              class="form__checkbox"
            />

            <label for="agree_2" class="form-check-label"
              ><span style="color: red; margin-left: 15px">*</span>
              Niniejszym potwierdzam, że zapoznałem/zapoznałam się z
              <a href="https://geberitpro.pl/admin/public/regulamin.pdf"
                >Regulaminem</a
              >
              Programu Partnerskiego Geberit Pro i akceptuję wszystkie jego
              postanowienia.
            </label>

            <validation-error :error="form.errors.agree_2" />
          </div>

          <div class="form__input-container">
            <input
              type="checkbox"
              id="agree_3"
              v-model="form.agree_3"
              class="form__checkbox"
            />

            <label for="agree_3" class="form-check-label">
              Wyrażam zgodę na przetwarzanie moich danych osobowych, wskazanych
              w formularzu przez spółkę Geberit sp. z o.o. z siedzibą w
              Warszawie, przy ul. Postępu 1, 02-676 Warszawa, wpisaną do
              rejestru przedsiębiorców KRS pod numerem: 0000038776 (dalej jako
              Administrator) w celu prowadzenia działań marketingowych i
              promocyjnych produktów Geberit.
            </label>
            <validation-error :error="form.errors.agree_3" />
          </div>
        </div>

        <div class="form__input-container">
          <input
            type="checkbox"
            id="agree_4"
            v-model="form.agree_4"
            class="form__checkbox"
          />

          <label for="agree_4" class="form-check-label"
            >Wyrażam zgodę na otrzymywanie od spółki Geberit sp. z o.o. z
            siedzibą w Warszawie, przy ul. Postępu 1, 02-676 Warszawa, wpisanej
            do rejestru przedsiębiorców KRS pod numerem: 0000038776 (dalej jako
            Administrator), informacji handlowych i materiałów promocyjnych
            środkami komunikacji elektronicznej w rozumieniu ustawy z dnia 18
            lipca 2002 r. o świadczeniu usług drogą elektroniczną.
          </label>
          <validation-error :error="form.errors.agree_4" />
        </div>
        <div class="form__input-container login__forget-password">
          <button type="submit" class="button button--blue form__submit">
            Zarejestruj się
          </button>
        </div>
        <div class="form__input-container login__forget-password">
          <router-link :to="{ name: 'Welcome' }">Wróć</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import AuthenticationService from "@/app/authentication/authentication.service";

import ValidationError from "../components/ValidationError.vue";

export default {
  name: "Register",
  components: {
    ValidationError,
  },
  data() {
    return {
      error: "",
      pending: false,
      form: {
        errors: {},
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        agree_1: false,
        agree_2: false,
        agree_5: false,
        agree_6: false,
        password: "",
        company: "",
        nip: "",
        website: "",
        password: "",
        password_confirmation: "",
        address: {
          address: "",
          city: "",
          postal_code: "",
        },
      },
    };
  },
  methods: {
    /**
     * Login method.
     *
     * @return {void}
     */
    register: function (e) {
      e.preventDefault();

      let vm = this;
      vm.error = "";
      vm.pending = true;

      AuthenticationService.register(vm.form)
        .then((response) => {
          vm.pending = false;
        })
        .catch((error) => {
          this.form.errors = error.response.data.errors;
          console.log(this.form.errors);
          vm.pending = false;
          vm.error = error.response.data.message;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/app/authentication/Register.vue